import { render } from "./SupportDetailView.vue?vue&type=template&id=4bf2c8e0&scoped=true"
import script from "./SupportDetailView.vue?vue&type=script&lang=js"
export * from "./SupportDetailView.vue?vue&type=script&lang=js"

import "./SupportDetailView.vue?vue&type=style&index=0&id=4bf2c8e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf2c8e0"]])

export default __exports__